import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';

export type PhoneInputProps = Omit<ISmartProps, 'css'>;
export const PhoneInput = React.forwardRef((props: PhoneInputProps, ref: any) => {
	const { readOnly, disabled, ...rest } = props;
	return <View {...rest} ref={ref} readOnly={readOnly} disabled={readOnly ? true : disabled} />;
});
